import React, {useEffect, useState, useReducer, useMemo} from 'react';
import './App.css';
import '@tencent/tea-component/lib/tea.css';
import type {RouteObject} from 'react-router-dom';
import {Outlet, Link, useRoutes, useLocation} from 'react-router-dom';
// import Home from "@src/routes/tmt_demo";
import TmtDemo from './routes/tmt_demo';
import ProductIntroduce from './routes/product_introduce';
import logo from './common/img/icon_header_logo.png';
import { Alert, Icon } from '@tencent/tea-component';
import classnames from 'classnames';
import debounce from './util/debounce';
import { doBeaconReport } from './util/beaconReport/index';
import { reducer, initState, AppContext, useDataContext } from './hooks/use-store';
import { languageReportMap } from './config/languageConfig';
 
import useEnv from './hooks/use-env';

export default function App() {
  const [state, dispatch] = useReducer(reducer, initState);
  const routes: RouteObject[] = [
    {
      path: '/',
      element: <Layout/>,
      children: [
        {index: true, element: <TmtDemo/>},
        {
          path: '/productIntroduce',
          element: <ProductIntroduce/>
        },
        {path: '*', element: <TmtDemo/>},
      ],
    },
  ];

  // The useRoutes() hook allows you to define your routes as JavaScript objects
  // instead of <Routes> and <Route> elements. This is really just a style
  // preference for those who prefer to not use JSX for their routes config.
  const element = useRoutes(routes);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      <div style={{height: '100%'}}>
        {element}
      </div>
    </AppContext.Provider>
  );
}

function Layout() {
  const { state: {
    curSourceLanguage, curTargetLanguage
  }} = useDataContext();
  const location = useLocation();
  const [windowIsScrollTop, setWindowIsScrollTop] = useState(true);
  const [isSingleScreen, setIsSingleScreen] = useState(false);

  // 首页公告条是否展示
  const [alertVisible, setAlertVisible] = useState<boolean>(true);
  // 头部导航栏是否fixed定位
  const [isFixed, setIsFixed] = useState<boolean>(false);

  // 获取当前的源语言和目标语言
  const getReportLanguage = useMemo(() => {
    return {
      source_language: languageReportMap[curSourceLanguage as keyof typeof languageReportMap],
      target_language: languageReportMap[curTargetLanguage as keyof typeof languageReportMap],
    }
  }, [curSourceLanguage, curTargetLanguage]);
  const { isTest } = useEnv();
  
  const openNewPage = () => {
    const targetUrl = 'https://cloud.tencent.com/product/tmt';
    window.open(targetUrl, '_blank');
  };

  const closeHandler = (event: React.MouseEvent) => {
    event.stopPropagation();
    setAlertVisible(false);
    resetScrollTop();
  };

  const resetScrollTop = () => {
    document.documentElement.scrollTop = 0;
    window.pageYOffset = 0;
    document.body.scrollTop = 0;
  };

  const jumpToMachine = () => {
    doBeaconReport('e#web_main#tencent_cloud_machine_translation#click', {
      ...getReportLanguage,
    });
  }
  // 接入环境通插件
  const loadSwitchEnv = () => {
    const cleRouteScript = document.createElement('script');
    cleRouteScript.type = 'text/javascript';
    cleRouteScript.src = 'https://mirrors.tencent.com/repository/generic/cle-env-switch/latest/cle-switch.min.js?projectId=17679';
    document.body.appendChild(cleRouteScript);
  };


  useEffect(() => {
    // 测试环境加载环境通小圆球
    if (isTest()) {
      loadSwitchEnv();
    }
    const checkSingleScreen = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      setIsSingleScreen(windowHeight >= documentHeight);
    };
  
    const handleScroll = debounce(() => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      setWindowIsScrollTop(scrollTop === 0);
      setIsFixed(scrollTop > 48);      
    }, 10);
  
    checkSingleScreen();
    handleScroll();

    window.addEventListener('resize', checkSingleScreen);
    window.addEventListener('scroll', handleScroll);
  
    return () => {
      window.removeEventListener('resize', checkSingleScreen);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location.pathname]);

  return (
    <div style={{height: '100%'}}>
      <div onClick={openNewPage} className='home-page-alert'>
        <Alert
          type='info'
          hideIcon
          visible={alertVisible}
          extra={
            <Icon className='alert-close-btn' type='close' onClick={closeHandler} />
          }
        >
          <a href=''>
            腾讯翻译君API服务将于2025年4月15日正式关闭，有翻译API需求的用户，可前往腾讯云机器翻译开通使用
          </a>
        </Alert>
      </div>
      <nav
        className={classnames('nav-content', {
          'scroll-bg': !windowIsScrollTop,
          'one-screen': isSingleScreen,
          'is-fixed': isFixed,
        })}
      >
        <div className='container nav-container'>
          <div className='nav-left'>
            <img src={logo} alt=""/>
          </div>
          <ul className='nav-right'>
            <li className={location.pathname === '/' ? 'active' : ''}><Link to="/">在线翻译</Link></li>
            <li className={location.pathname === '/productIntroduce' ? 'active' : ''}><Link
              to="/productIntroduce">产品介绍</Link></li>
            <li className='outside-link' onClick={jumpToMachine}><Link to="https://cloud.tencent.com/product/tmt">腾讯云机器翻译</Link></li>
          </ul>
        </div>
      </nav>
      <Outlet/>
    </div>
  );
}

